
; /*!
 * jQuery Raty - A Star Rating Plugin
 *
 * Licensed under The MIT License
 *
 * @version        2.4.5
 * @author         Washington Botelho
 * @documentation  wbotelhos.com/raty
 * 
 */

(function(b){
    var a={
        init:function(c){
            return this.each(function(){
                var d=this,
                h=b(d).empty();
                d.opt=b.extend(true,{},b.fn.raty.defaults,c);
                h.data("settings",d.opt);
                d.opt.number=a.between(d.opt.number,0,20);
                if(d.opt.path.substring(d.opt.path.length-1,d.opt.path.length)!="/"){
                    d.opt.path+="/";
                }
                if(typeof d.opt.score=="function"){
                    d.opt.score=d.opt.score.call(d);
                }
                if(d.opt.score){
                    d.opt.score=a.between(d.opt.score,0,d.opt.number);
                }
                for(var e=1;e<=d.opt.number;e++){
                    b("<img />",{src:d.opt.path+((!d.opt.score||d.opt.score<e)?d.opt.starOff:d.opt.starOn),alt:e,title:(e<=d.opt.hints.length&&d.opt.hints[e-1]!==null)?d.opt.hints[e-1]:e}).appendTo(d);
                    if(d.opt.space){
                        h.append((e<d.opt.number)?"&#160;":"");
                    }
                }
                d.stars=h.children('img:not(".raty-cancel")');
                d.score=b("<input />",{type:"hidden",name:d.opt.scoreName}).appendTo(d);
                if(d.opt.score&&d.opt.score>0)
                {
                    d.score.val(d.opt.score);
                    a.roundStar.call(d,d.opt.score);
                }
                if(d.opt.iconRange)
                {
                    a.fill.call(d,d.opt.score);
                }
                a.setTarget.call(d,d.opt.score,d.opt.targetKeep);
                var g=d.opt.space?4:0,f=d.opt.width||(d.opt.number*d.opt.size+d.opt.number*g);
                if(d.opt.cancel){
                    d.cancel=b("<img />",{src:d.opt.path+d.opt.cancelOff,alt:"x",title:d.opt.cancelHint,"class":"raty-cancel"});
                    if(d.opt.cancelPlace=="left"){
                        h.prepend("&#160;").prepend(d.cancel);
                    }else{
                        h.append("&#160;").append(d.cancel);
                    }
                    f+=(d.opt.size+g);
                }if(d.opt.readOnly){a.fixHint.call(d);
                    if(d.cancel){
                        d.cancel.hide();
                    }
                }else{
                    h.css("cursor","pointer");a.bindAction.call(d);
                }
                h.css("width",f);
            });
        },
        between:function(e,d,c){
            return Math.min(Math.max(parseFloat(e),d),c);
        },
        bindAction:
            function(){
                var c=this,e=b(c);
                e.mouseleave(function(){
                    var f=c.score.val()||undefined;a.initialize.call(c,f);
                    a.setTarget.call(c,f,c.opt.targetKeep);
                    if(c.opt.mouseover){
                        c.opt.mouseover.call(c,f);
                    }});
                var d=c.opt.half?"mousemove":"mouseover";
                if(c.opt.cancel){
                    c.cancel.mouseenter(function(){
                        b(this).attr("src",c.opt.path+c.opt.cancelOn);
                        c.stars.attr("src",c.opt.path+c.opt.starOff);
                        a.setTarget.call(c,null,true);
                        if(c.opt.mouseover){
                            c.opt.mouseover.call(c,null);
                        }}).mouseleave(function(){
                            b(this).attr("src",c.opt.path+c.opt.cancelOff);
                            if(c.opt.mouseover){
                                c.opt.mouseover.call(c,c.score.val()||null);
                            }}).click(function(f){
                            c.score.removeAttr("value");
                            if(c.opt.click){c.opt.click.call(c,null,f);
                            }});
                }
                c.stars.bind(d,function(g){var h=parseInt(this.alt,10);
                    if(c.opt.half){
                        var f=parseFloat((g.pageX-b(this).offset().left)/c.opt.size),i=(f>0.5)?1:0.5;h=parseFloat(this.alt)-1+i;a.fill.call(c,h);
                        if(c.opt.precision){h=h-i+f;}a.showHalf.call(c,h);}else{a.fill.call(c,h);
                    }e.data("score",h);a.setTarget.call(c,h,true);
                    if(c.opt.mouseover){c.opt.mouseover.call(c,h,g);}}).click(function(f){
                        c.score.val((c.opt.half||c.opt.precision)?e.data("score"):this.alt);
                        if(c.opt.click){
                            c.opt.click.call(c,c.score.val(),f);
                        }
                    });
            },
        cancel:function(c){
            return b(this).each(function(){
                var d=this,e=b(d);
                if(e.data("readonly")===true){
                    return this;
                }
                if(c){
                    a.click.call(d,null);
                }else{
                    a.score.call(d,null);
                }
                d.score.removeAttr("value");
            });
        },
        click:function(c){return b(this).each(function(){if(b(this).data("readonly")===true){return this;}a.initialize.call(this,c);if(this.opt.click){this.opt.click.call(this,c);}else{a.error.call(this,'you must add the "click: function(score, evt) { }" callback.');}a.setTarget.call(this,c,true);});},
        error:function(c){b(this).html(c);b.error(c);},
        fill:function(k){var c=this,h=c.stars.length,g=0,d,j,f;for(var e=1;e<=h;e++){d=c.stars.eq(e-1);if(c.opt.iconRange&&c.opt.iconRange.length>g){j=c.opt.iconRange[g];if(c.opt.single){f=(e==k)?(j.on||c.opt.starOn):(j.off||c.opt.starOff);}else{f=(e<=k)?(j.on||c.opt.starOn):(j.off||c.opt.starOff);}if(e<=j.range){d.attr("src",c.opt.path+f);}if(e==j.range){g++;}}else{if(c.opt.single){f=(e==k)?c.opt.starOn:c.opt.starOff;}else{f=(e<=k)?c.opt.starOn:c.opt.starOff;}d.attr("src",c.opt.path+f);}}},
        fixHint:function(){var c=b(this),e=parseInt(this.score.val(),10),d=this.opt.noRatedMsg;if(!isNaN(e)&&e>0){d=(e<=this.opt.hints.length&&this.opt.hints[e-1]!==null)?this.opt.hints[e-1]:e;}c.data("readonly",true).css("cursor","default").attr("title",d);this.score.attr("readonly","readonly");this.stars.attr("title",d);},
        getScore:function(){var d=[],c;b(this).each(function(){c=this.score.val();d.push(c?parseFloat(c):undefined);});return(d.length>1)?d:d[0];},
        readOnly:function(c){return this.each(function(){var d=b(this);if(d.data("readonly")===c){return this;}if(this.cancel){if(c){this.cancel.hide();}else{this.cancel.show();}}if(c){d.unbind();d.children("img").unbind();a.fixHint.call(this);}else{a.bindAction.call(this);a.unfixHint.call(this);}d.data("readonly",c);});},
        reload:function(){return a.set.call(this,{});},roundStar:function(e){var d=(e-Math.floor(e)).toFixed(2);if(d>this.opt.round.down){var c=this.opt.starOn;if(d<this.opt.round.up&&this.opt.halfShow){c=this.opt.starHalf;}else{if(d<this.opt.round.full){c=this.opt.starOff;}}this.stars.eq(Math.ceil(e)-1).attr("src",this.opt.path+c);}},
        score:function(){return arguments.length?a.setScore.apply(this,arguments):a.getScore.call(this);},set:function(c){this.each(function(){var d=b(this),f=d.data("settings"),e=d.clone().removeAttr("style").insertBefore(d);d.remove();e.raty(b.extend(f,c));});return b(this.selector);},
        setScore:function(c){return b(this).each(function(){if(b(this).data("readonly")===true){return this;}a.initialize.call(this,c);a.setTarget.call(this,c,true);});},setTarget:function(e,d){if(this.opt.target){var c=b(this.opt.target);if(c.length==0){a.error.call(this,"target selector invalid or missing!");}var f=e;if(!d||f===undefined){f=this.opt.targetText;}else{if(this.opt.targetType=="hint"){f=(f===null&&this.opt.cancel)?this.opt.cancelHint:this.opt.hints[Math.ceil(f-1)];}else{f=this.opt.precision?parseFloat(f).toFixed(1):parseInt(f,10);}}if(this.opt.targetFormat.indexOf("{score}")<0){a.error.call(this,'template "{score}" missing!');}if(e!==null){f=this.opt.targetFormat.toString().replace("{score}",f);}if(c.is(":input")){c.val(f);}else{c.html(f);}}},showHalf:function(d){var c=(d-Math.floor(d)).toFixed(1);if(c>0&&c<0.6){this.stars.eq(Math.ceil(d)-1).attr("src",this.opt.path+this.opt.starHalf);}},initialize:function(c){c=!c?0:a.between(c,0,this.opt.number);a.fill.call(this,c);if(c>0){if(this.opt.halfShow){a.roundStar.call(this,c);}this.score.val(c);}},unfixHint:function(){for(var c=0;c<this.opt.number;c++){this.stars.eq(c).attr("title",(c<this.opt.hints.length&&this.opt.hints[c]!==null)?this.opt.hints[c]:c);}b(this).data("readonly",false).css("cursor","pointer").removeAttr("title");this.score.attr("readonly","readonly");}};b.fn.raty=function(c){if(a[c]){return a[c].apply(this,Array.prototype.slice.call(arguments,1));}else{if(typeof c==="object"||!c){return a.init.apply(this,arguments);}else{b.error("Method "+c+" does not exist!");}}};b.fn.raty.defaults={cancel:false,cancelHint:"cancel this rating!",cancelOff:"cancel-off.png",cancelOn:"cancel-on.png",cancelPlace:"left",click:undefined,half:false,halfShow:true,hints:["Bad","Poor","Regular","Good","Gorgeous"],iconRange:undefined,mouseover:undefined,noRatedMsg:"not rated yet",number:5,path:"img/",precision:false,round:{down:0.25,full:0.6,up:0.76},readOnly:false,score:undefined,scoreName:"score",single:false,size:16,space:true,starHalf:"star-half.png",starOff:"star-off.png",starOn:"star-on.png",target:undefined,targetFormat:"{score}",targetKeep:false,targetText:"",targetType:"hint",width:undefined};})(jQuery);

; /*
 * Stepper v3.0.7 - 2014-11-25
 * A jQuery plugin for cross browser number inputs. Part of the Formstone Library.
 * http://formstone.it/stepper/
 *
 * Copyright 2014 Ben Plum; MIT Licensed
 */

;(function ($, window) {
	"use strict";

	/**
	 * @options
	 * @param customClass [string] <''> "Class applied to instance"
	 * @param lables.up [string] <'Up'> "Up arrow label"
	 * @param lables.down [string] <'Down'> "Down arrow label"
	 */
	var options = {
		customClass: "",
		labels: {
			up: "Up",
			down: "Down"
		}
	};

	var pub = {

		/**
		 * @method
		 * @name defaults
		 * @description Sets default plugin options
		 * @param opts [object] <{}> "Options object"
		 * @example $.stepper("defaults", opts);
		 */
		defaults: function(opts) {
			options = $.extend(options, opts || {});
			return (typeof this === 'object') ? $(this) : true;
		},

		/**
		 * @method
		 * @name destroy
		 * @description Removes instance of plugin
		 * @example $(".target").stepper("destroy");
		 */
		destroy: function() {
			return $(this).each(function(i) {
				var data = $(this).data("stepper");

				if (data) {
					// Unbind click events
					data.$stepper.off(".stepper")
								 .find(".stepper-arrow")
								 .remove();

					// Restore DOM
					data.$input.unwrap()
							   .removeClass("stepper-input");
				}
			});
		},

		/**
		 * @method
		 * @name disable
		 * @description Disables target instance
		 * @example $(".target").stepper("disable");
		 */
		disable: function() {
			return $(this).each(function(i) {
				var data = $(this).data("stepper");

				if (data) {
					data.$input.attr("disabled", "disabled");
					data.$stepper.addClass("disabled");
				}
			});
		},

		/**
		 * @method
		 * @name enable
		 * @description Enables target instance
		 * @example $(".target").stepper("enable");
		 */
		enable: function() {
			return $(this).each(function(i) {
				var data = $(this).data("stepper");

				if (data) {
					data.$input.attr("disabled", null);
					data.$stepper.removeClass("disabled");
				}
			});
		}
	};

	/**
	 * @method private
	 * @name _init
	 * @description Initializes plugin
	 * @param opts [object] "Initialization options"
	 */
	function _init(opts) {
		// Local options
		opts = $.extend({}, options, opts || {});

		// Apply to each element
		var $items = $(this);
		for (var i = 0, count = $items.length; i < count; i++) {
			_build($items.eq(i), opts);
		}
		return $items;
	}

	/**
	 * @method private
	 * @name _build
	 * @description Builds each instance
	 * @param $select [jQuery object] "Target jQuery object"
	 * @param opts [object] <{}> "Options object"
	 */
	function _build($input, opts) {
		if (!$input.hasClass("stepper-input")) {
			// EXTEND OPTIONS
			opts = $.extend({}, opts, $input.data("stepper-options"));

			// HTML5 attributes
			var min = parseFloat($input.attr("spin-min")),
				max = parseFloat($input.attr("spin-max")),
				initial_step = parseFloat($input.attr("spin-initial-step")),
				step = parseFloat($input.attr("spin-step")) || 1;

			// Modify DOM
			$input.addClass("stepper-input")
				  .wrap('<div class="stepper ' + opts.customClass + '" />')
				  .after('<span class="stepper-arrow up">' + opts.labels.up + '</span><span class="stepper-arrow down">' + opts.labels.down + '</span>');

			// Store data
			var $stepper = $input.parent(".stepper"),
				data = $.extend({
					$stepper: $stepper,
					$input: $input,
					$arrow: $stepper.find(".stepper-arrow"),
					min: (typeof min !== undefined && !isNaN(min)) ? min : false,
					max: (typeof max !== undefined && !isNaN(max)) ? max : false,
					step: (typeof step !== undefined && !isNaN(step)) ? step : 1,
					initial_step: (typeof initial_step !== undefined && !isNaN(initial_step)) ? initial_step : undefined,
					timer: null,
					et_data: {up: {clazz: "", attr: {}}, down: {clazz: "", attr: {}}}
				}, opts);
            if(data.et_data) {
                var up = data.et_data['up'];
                var down = data.et_data['down'];
                $stepper.find(".stepper-arrow.up").addClass(up.clazz).attr(up.attr);
                $stepper.find(".stepper-arrow.down").addClass(down.clazz).attr(down.attr);
            }

			data.digits = _digits(data.step);

			// Check disabled
			if ($input.is(":disabled")) {
				$stepper.addClass("disabled");
			}

			// Bind keyboard events
			$stepper.on("keypress", ".stepper-input", data, _onKeyup);

			// Bind click events
			$stepper.on("touchstart.stepper mousedown.stepper", ".stepper-arrow", data, _onMouseDown);

			// Store data on the element itself
			$input.data("stepper", data);
		}
	}

	/**
	 * @method private
	 * @name _onKeyup
	 * @description Handles keypress event on inputs
	 * @param e [object] "Event data"
	 */
	function _onKeyup(e) {
		var data = e.data;

		// If arrow keys
		if (e.keyCode === 38 || e.keyCode === 40) {
			e.preventDefault();

			_step(data, (e.keyCode === 38) ? data.step : -data.step);
		}
	}

	/**
	 * @method private
	 * @name _onMouseDown
	 * @description Handles mousedown event on instance arrows
	 * @param e [object] "Event data"
	 */
	function _onMouseDown(e) {
		e.preventDefault();
		e.stopPropagation();

		// Make sure we reset the states
		_onMouseUp(e);

		var data = e.data;

		if (!data.$input.is(':disabled') && !data.$stepper.hasClass("disabled")) {
			var change = $(e.target).hasClass("up") ? data.step : -data.step;

			data.timer = _startTimer(data.timer, 200, function() {
				_step(data, change, false);
			});
			_step(data, change);

			$("body").on("touchend.stepper mouseup.stepper", data, _onMouseUp);
		}
	}

	/**
	 * @method private
	 * @name _onMouseUp
	 * @description Handles mouseup event on instance arrows
	 * @param e [object] "Event data"
	 */
	function _onMouseUp(e) {
		e.preventDefault();
		e.stopPropagation();

		var data = e.data;

		data.timer = _clearTimer(data.timer, data);

		$("body").off(".stepper");
	}

	/**
	 * @method private
	 * @name _step
	 * @description Steps through values
	 * @param e [object] "Event data"
	 * @param change [string] "Change value"
	 */
	function _step(data, change) {
		var originalValue = parseFloat(data.$input.val()),
			value = change;
		if(((Math.sign(change) == -1) &&  (data.initial_step == originalValue)) || ((Math.sign(change) == 1) &&  data.initial_step && (originalValue == 0))){
			if((data.initial_step == originalValue) && (Math.sign(change) == -1)){
				value = 0
			}else{
				value = data.initial_step
			}
		}
		else if (typeof originalValue === undefined || isNaN(originalValue)) {
			if (data.min !== false) {
				value = data.min;
			} else {
				value = 0;
			}
		} else if (data.min !== false && originalValue < data.min) {
			value = data.min;
		} else {
			value += originalValue;
		}

		var diff = (value - data.min) % data.step;
		if (diff !== 0) {
			value -= diff;
		}
		if (data.max !== false && value > data.max) {
			value = data.max
			data.$stepper.trigger("max")
		}
		if (data.min !== false && value < data.min) {
			value = data.min;
			data.$stepper.trigger("min")
		}
		if (value !== originalValue) {
			value = _round(value, data.digits);
			data.$input.trigger("before-step-change");
			data.$input.val(value).trigger("change", ["" + value, "" + originalValue]);
		}
	}

	/**
	 * @method private
	 * @name _startTimer
	 * @description Starts an internal timer
	 * @param timer [int] "Timer ID"
	 * @param time [int] "Time until execution"
	 * @param callback [int] "Function to execute"
	 */
	function _startTimer(timer, time, callback) {
		_clearTimer(timer, null);
		return setInterval(callback, time);
	}

	/**
	 * @method private
	 * @name _clearTimer
	 * @description Clears an internal timer
	 * @param timer [int] "Timer ID"
	 * @param data [object] "Data object containing timer reference"
	 */
	function _clearTimer(timer, data) {
		if (timer) {
			clearInterval(timer);
			if (data) {
				data.timer = null;
			}
		}
		return null;
	}

	/**
	 * @method private
	 * @name _digits
	 * @description Analyzes and returns significant digit count
	 * @param value [float] "Value to analyze"
	 * @return [int] "Number of significant digits"
	 */
	function _digits(value) {
		var test = String(value);
		if (test.indexOf(".") > -1) {
			return test.length - test.indexOf(".") - 1;
		} else {
			return 0;
		}
	}

	/**
	 * @method private
	 * @name _round
	 * @description Rounds a number to a sepcific significant digit count
	 * @param value [float] "Value to round"
	 * @param digits [float] "Digits to round to"
	 * @return [number] "Rounded number"
	 */
	function _round(value, digits) {
		var exp = Math.pow(10, digits);
		return Math.round(value * exp) / exp;
	}

	$.fn.stepper = function(method) {
		if (pub[method]) {
			return pub[method].apply(this, Array.prototype.slice.call(arguments, 1));
		} else if (typeof method === 'object' || !method) {
			if(method && method.max == "") {
				delete method.max
			}
			return _init.apply(this, arguments);
		}
		return this;
	};

	$.stepper = function(method) {
		if (method === "defaults") {
			pub.defaults.apply(this, Array.prototype.slice.call(arguments, 1));
		}
	};
})(jQuery, this);

; 
(function($) {

    var defaults = {
        reCalcOnWindowResize: true,
        throttleDuration: 17
    };

    var setupContainer = function($el) {
        var imageSrc = $el.find('img').attr('src');
        $el.data('imageSrc', imageSrc);
        resolveImageSize(imageSrc, function(err, dim) {
            $el.data({
                imageW: dim.width,
                imageH: dim.height
            });
            adjustFocus($el);
        });
    };

    var resolveImageSize = function(src, cb) {
        $('<img />').one('load', function() {
            cb(null, {
                width: this.width,
                height: this.height
            });
        }).attr('src', src);
    };

    var throttle = function(fn, ms) {
        var isRunning = false;
        return function() {
            var args = Array.prototype.slice.call(arguments, 0);
            if (isRunning) return false;
            isRunning = true;
            setTimeout(function() {
                isRunning = false;
                fn.apply(null, args);
            }, ms);
        };
    };

    var calcShift = function(conToImageRatio, containerSize, imageSize, focusSize, toMinus) {
        var containerCenter = Math.floor(containerSize / 2);
        var focusFactor = (focusSize + 1) / 2;
        var scaledImage = Math.floor(imageSize / conToImageRatio);
        var focus =  Math.floor(focusFactor * scaledImage);
        if (toMinus) focus = scaledImage - focus;
        var focusOffset = focus - containerCenter;
        var remainder = scaledImage - focus;
        var containerRemainder = containerSize - containerCenter;
        if (remainder < containerRemainder) focusOffset -= containerRemainder - remainder;
        if (focusOffset < 0) focusOffset = 0;
        return (focusOffset * -100 / containerSize)  + '%';
    };


    var adjustFocus = function($el) {
        var imageW = $el.data('imageW');
        var imageH = $el.data('imageH');
        var imageSrc = $el.data('imageSrc');

        if (!imageW && !imageH && !imageSrc) {
            return setupContainer($el);
        }

        var containerW = $el.outerWidth();
        var containerH = $el.outerHeight();
        var focusX = parseFloat($el.data('focusX'));
        var focusY = parseFloat($el.data('focusY'));
        var $image = $el.find('img').first();

        var hShift = 0;
        var vShift = 0;

        if (!(containerW > 0 && containerH > 0 && imageW > 0 && imageH > 0)) {
            return false;
        }

        var wR = imageW / containerW;
        var hR = imageH / containerH;

        $image.css({
            'max-width': '',
            'max-height': ''
        });

        if (imageW > containerW && imageH > containerH) {
            $image.css((wR > hR) ? 'max-height' : 'max-width', '100%');
        }

        $image.css((wR > hR) ? 'max-width' : 'max-height', 'none');

        if (wR > hR) {
            hShift = calcShift(hR, containerW, imageW, focusX);
        } else if (wR < hR) {
            vShift = calcShift(wR, containerH, imageH, focusY, true);
        }

        $image.css({
            top: vShift,
            left: hShift
        });

    };

    var $window = $(window);

    var focusPoint = function($el, settings) {
        var thrAdjustFocus = settings.throttleDuration ?
            throttle(function(){adjustFocus($el);}, settings.throttleDuration)
            : function(){adjustFocus($el);};
        var isListening = false;

        adjustFocus($el);

        return {
            adjustFocus: function() {
                return adjustFocus($el);
            },
            windowOn: function() {
                if (isListening) return;
                $window.on('resize', thrAdjustFocus);
                return isListening = true;
            },
            windowOff: function() {
                if (!isListening) return;
                $window.off('resize', thrAdjustFocus);
                isListening = false;
                return true;
            }
        };
    };

    $.fn.focusPoint = function(optionsOrMethod) {
        if (typeof optionsOrMethod === 'string') {
            return this.each(function() {
                var $el = $(this);
                $el.data('focusPoint')[optionsOrMethod]();
            });
        }

        var settings = $.extend({}, defaults, optionsOrMethod);
        return this.each(function() {
            var $el = $(this);
            var fp = focusPoint($el, settings);
            if ($el.data('focusPoint')) $el.data('focusPoint').windowOff();
            $el.data('focusPoint', fp);
            if (settings.reCalcOnWindowResize) fp.windowOn();
        });

    };

    $.fn.adjustFocus = function() {
        return this.each(function() {
            adjustFocus($(this));
        });
    };

})(jQuery);
; $(function() {
    var page = $(".page-content");
    var widgets = page.find(".widget-variation .variation-container");
    var productListWidgets = page.find(".widget-variation-product-list .variation-container");

    var loader = "<div><span class='vertical-aligner'></span><img src='" + app.systemResourceUrl + "plugins/variation/images/site/loading.gif'></div>";
    if(widgets.length) {
        var advancedUi = widgets.find(".advanced-variation-ui");
        if(advancedUi.length) {
            page.find(".product-widget.widget-price").attr({'style': "display: none !important;"});
            page.find(".product-widget.widget-addCart .stepper").attr({'style': "display: none !important;"});
        }
        widgets.each(function() {
            var widget = this.jqObject;
            var pId = widget.find("input[name=productId]").val();
            widget.data("loader", loader);
            initializeVariation(pId, page, widget);
        })
    }

    if(productListWidgets.length) {
        productListWidgets.each(function() {
            var widget = this.jqObject;
            var pId = widget.find("input[name=productId]").val();
            widget.data("loader", loader);
            initializeVariationInProductList(pId, widget);
        })
    }

    function initializeVariation(productId, content, widget) {
        var type = widget.find(".variation-model");
        if(type.length) {
            var select = widget.find("div.product-variation-select:not(.combined)");
            if(select.length) {
                select.chosen({
                    disable_search_threshold: 10,
                    disable_search: true
                });
            }
            var func = "initialise" + type.val().capitalize() + "VariationWidget";
            bm.onReady(window, func, function() {
                window[func](productId, content, widget);
                // HWC-100: previously this called .off("change") here, stripping the change handler
                // that the variation-model widget (e.g. site.enterprise-variation.js) had just
                // installed. With that handler gone, picking a variation in the chosen dropdown
                // (defaultView, rendered when "Select variation view" is OFF) had no working
                // listener — so the price never updated even though the option visually toggled.
                // Leave the model-specific handler in place; it routes through loadVariation() →
                // loadVariationProductUrl, which navigates to the variation's own URL where the
                // correct price renders.
            })
        }
    }

     function initializeVariationInProductList(productId, widget) {
            var type = widget.find(".variation-model");
            if(type.length) {
                var func = "initVariationSelectionInProductList";
                bm.onReady(window, func, function() {
                    window[func](productId, widget);
                })
            }
        }

    app.global_event.on("initialize-info-chose-popup", function(evt, productId, content) {
        // This file ships in ResourceList.fixedSiteUIJs (every storefront page), but
        // initVariationSelection lives in variation-selection.js, which ProductVariationTagLib.siteJSs
        // only emits when ALLOW_VARIATION_FEATURE is licensed. Without this guard the ReferenceError
        // unwinds out of app.global_event.trigger() in renderInfoChooserPopup and the info-chooser
        // popup never renders at all.
        if (typeof initVariationSelection !== "function") {
            return;
        }
        initVariationSelection(productId, content);
    })

    site.hook.register("prepareAddCartData", function(data, container, productId, quantity, priceOnly) {
        if(!priceOnly) {
            var combinationForm = container.find(".variation-container");
            var includedProductsForm = container.find(".variation-container.combind-product-variation")
            if(combinationForm.length) {
                var matrix = combinationForm.find(".combination-matrix");
                var thumb = combinationForm.find(".variation-thumb");
                if(matrix.length) {
                    var cell = matrix.find(".selected");
                    data['config.variation'] = cell.attr("v-id");
                } else if(thumb.length) {
                    var options = [];
                    thumb.find(".option-cell.selected").each(function() {
                        options.push($(this).attr("option-id"));
                    });
                    $.extend(data, {'config.options': options});
                } else {
                    var options = combinationForm.serializeObject();
                    $.extend(data, options);
                }
            }
            if (data && data.included) {
                $.extend(data, includedProductsForm.serializeObject())
            }
        }
        return data;
    });

    app.global_event.on("after-product-info-view-initialize", function(evt, productId, content, type, callback) {
        var widget = content.find(".variation-container");
        var modeType = widget.find(".variation-model");
        var description = true;
        if(modeType.length) {
            var matrix = widget.find(".matrix");
            matrix.find(".cell.available").on("click", function() {
                var cell = $(this);
                if(!cell.is(".selected")) {
                    var data = {productId: productId, 'config.variation': cell.attr("v-id"), enableDescription: description};
                    updateCombination(data);
                }
            })
            var select = widget.find("div.product-variation-select");
            if(select.length) {
                select.chosen({
                    disable_search_threshold: 10,
                    disable_search: true
                });
                select = content.find("select.product-variation-select");
                select.on("change", function(ev) {
                    var data = widget.serializeObject();
                    data.enableDescription = description;
                    updateCombination(data);
                })

            }
            var thumbView = widget.find(".variation-thumb");
            thumbView.find(".option-cell").on("click", function() {
                var $this = $(this);
                var ids = [$this.attr("option-id")];
                var types = thumbView.find(".variation-type").not($this.parents(".variation-type"));
                types.each(function() {
                    ids.push($(this).find(".option-cell.selected").attr("option-id"));
                });
                var data = {productId: productId, 'config.options': ids, enableDescription: description};
                updateCombination(data);
            })
        }

        function updateCombination(data) {
            bm.mask(content, loader);
            var shortViewContainer = content.find(".product-info-view-container");
            data.viewType = type;
            bm.ajax({
                url: app.baseUrl + "variation/loadVariationForProductShortView",
                data: data,
                dataType: "html",
                response: function() {
                    bm.unmask(content);
                },
                success: function(resp) {
                    shortViewContainer.replaceWith(resp);
                    if(type == "details") {
                        content.find(".widget-information, .widget-related, .widget-similar, .widget-shipmentCalculator").remove()
                    }
                    bm.ajax({
                        url: app.baseUrl + "variation/loadVariationContainerForDetailPage",
                        data: data,
                        dataType: "html",
                        success: function(varHtml) {
                            content.find(".variation-container").replaceWith(varHtml);
                            initializeProductInfoView(productId, content, type, callback);
                        }
                    });
                }
            })
        }
    });

    var select = page.find(".product-variation-select.combined");
    if(select.length) {
        select.chosen({
            disable_search_threshold: 10,
            disable_search: true
        });
    }

   /* page.find(".variation-options-table .variation-option").on("click", function (){
        var _this = this;
        var productPanel = _this.jqObject.parent().parent().parent().parent().parent().parent().parent()
        productPanel.find(".representation .variation-option").removeClass("selected")
        bm.ajax({
            url: app.baseUrl + "variation/variationWiseProductImage",
            data: {optionId: this.jqObject.attr("optionid"), productId: productPanel.attr("product-id")},
            dataType: "json",
            success: function(resp) {
                if(resp.status === "success"){
                    productPanel.find(".product-image-link.image-link").find("img").attr("src",resp.imageUrl)
                    productPanel.find(".product-image-link.image-link").find("img").attr("alt",resp.altText)
                    _this.jqObject.addClass("selected")
                }
            }
        })
    })*/

    site.hook.register("adjustAdditionalProductData", function(container, productId) {
        var optionSelector = container.find(".included-products-selection-table select.product-variation-select");
        optionSelector.on("change", function() {
            var optionIds = [];
            var varContainer = this.jqObject.closest(".variation-dropdown-container");
            var combinedId = varContainer.find(".combined.wcui-select").attr("included");
            optionIds.push(this.jqObject.val());
            var otherDom = this.jqObject.closest(".variation-type").siblings(".variation-type");
            var otherInputVal = otherDom.find("select.product-variation-select").val();
            if(!otherInputVal) {
                otherInputVal = otherDom.find(".combined-selected-variation-value").attr("optionId");
            }
            optionIds.push(otherInputVal);
            var imageDom = this.jqObject.closest(".info-row .image img");
            bm.ajax({
                url: app.baseUrl + "variation/getVariationImageUrlForCombinedProduct",
                data: {combinedId: combinedId, optionIds: optionIds},
                success: function (resp) {
                    if(resp.url) {
                        imageDom.prevObject.closest(".info-row").find(".image img").attr("src", resp.url);
                    }
                }
            });
        });

        return container;
    });

    var bindVariationProductQuantitySpinner = function(container) {
        var spinObj = container.find(".flying-cart-variation-product-quantity-selector");
        spinObj.each(function() {
            var spin = $(this);
            var data = spin.config("spin");
            data.et_data = {
                up: {clazz: "et_cartp_increase_quantity", attr: {'et-category': 'button'}},
                down: {clazz: "et_cartp_decrease_quantity", attr: {'et-category': 'button'}}
            };
            spin.stepper(data)
        })
    };

    site.hook.register("bind-flying-cart-events", function(flyingCartPopup) {
        $(".floating-popup.variation-more-options").hide()
        flyingCartPopup.find(".flying-cart-container .product-card__product-variation-more-combinations").unbind().on("click", function() {
            var panel = this.jqObject.next(".floating-popup")
            $(".floating-popup.variation-more-options").hide()
            bm.ajax({
                url: app.baseUrl + "variation/variationOppositeComb",
                data: {productId: this.jqObject.attr("productId"), selectedOption: this.jqObject.attr("selectedOption"), selectedValue: this.jqObject.attr("selectedValue")},
                dataType: 'html',
                success: function (resp) {
                    panel.html(resp)
                    panel.show()
                    var floatingPopup = panel
                    bindVariationProductQuantitySpinner(floatingPopup);

                    floatingPopup.find(".flying-cart-variation-quantity .stepper").on("min", function() {
                        var box = this.jqObject.find(".stepper-input");
                        box.trigger("ichange");
                    });

                    floatingPopup.find(".flying-cart-variation-quantity .stepper").on("max", function() {
                        var box = this.jqObject.find(".stepper-input");
                        box.trigger("ichange");
                    });

                    var quantitySelector = floatingPopup.find(".flying-cart-variation-product-quantity-selector");
                    quantitySelector.on("before-step-change", function()  {
                        $(this).focus();
                    });

                    //var flyingCartFooterCheckoutButton = popup.find(".flying-cart-footer-button.checkout-btn")
                    quantitySelector.ichange(10, function () {
                        floatingPopup.loader()
                        //flyingCartFooterCheckoutButton.addClass("disabled")
                        var ichangeThis = this
                        function ichangeQuantitySelector (){
                            var quantityInput = ichangeThis.jqObject
                            var itemId = quantityInput.attr("item-id");
                            var quantity = quantityInput.val();
                            if(quantity == 0 || !ichangeThis.value) {
                                return;
                            }
                            floatingPopup.loader(false)
                        }
                        setTimeout(ichangeQuantitySelector, 80)
                    }).numeric()

                    floatingPopup.find(".add-to-cart").click(function () {
                        var item = this.jqObject.siblings(".flying-cart-quantity-wrapper").find(".product-quantity-selector")
                        var optionsEle = this.jqObject.siblings(".flying-cart-quantity-wrapper")
                        site.hook.register("prepareAddCartData", function(data, container, productId, quantity, priceOnly) {
                            data['productId'] = item.attr("item-id");
                            data['quantity'] = item.val()
                            data['variationId'] = item.attr("variation-id")
                            var options = [];
                            optionsEle.find('input[name="option"]').each(function() {
                                options.push($(this).val());
                            });
                            data['config.options'] = options
                            data['sameAsCart'] = "yes"
                            return data;
                        });
                        floatingPopup.loader()
                        var excAddToCartThis = this
                        function excAddToCart(){
                            addProductInCart.call(excAddToCartThis)
                        }
                        setTimeout(excAddToCart, 700);
                    });
                }
            });
        });

        $(document).on("click", function (event) {
            // Check if the click is outside the .floating-popup.variation-more-options element
            if (!$(event.target).closest(".floating-popup.variation-more-options").length) {
                $(".floating-popup.variation-more-options").hide();
            }
        });

        flyingCartPopup.on("click", function (event) {
            if ($(event.target).closest(".floating-popup.variation-more-options").length) {
                event.stopPropagation();
                return;
            }

            if (!flyingCartPopup.find(".product-card__product-variation-more-combinations").is(event.target)) {
                $(".floating-popup.variation-more-options").hide();
            }

            if (flyingCartPopup.find(".floating-popup.variation-more-options").is(event.target)) {
                $(".floating-popup.variation-more-options").show();
            }
        });

    });

});

function updateOption(typeId, optionId, label) {
    const hiddenInput = document.getElementById('hidden-option-' + typeId);
    if (hiddenInput) {
        hiddenInput.value = optionId;
    }
    const display = document.querySelector(`#selected-display-${typeId} .selected-option-label`);
    if (display) {
        display.textContent = label;
    }
}


; function initialiseEnterpriseVariationWidget(productId, content, widget) {
    var matrix = widget.find(".matrix");
    matrix.find(".cell.available").on("click", function() {
        var cell = $(this);
        if(!cell.is(".selected")) {
            var data = {productId: productId, 'config.variation': cell.attr("v-id")};
            loadVariation(data);
        }
    })

    var select = widget.find("select.product-variation-select");
    select.on("change", function(ev) {
        var data = widget.serializeObject();
        data.productId = productId;
        loadVariation(data);
    });

    var advancedSelect = widget.find(".variation-options-table .variation-option.parent-option");
    advancedSelect.on("click", function(ev) {
        var data = widget.serializeObject();
        data.productId = productId;
        data["config.options"] = this.jqObject.attr("optionId");
        loadVariation(data);
    });

    var thumbView = widget.find(".variation-thumb");
    thumbView.find(".option-cell").on("click", function() {
        widget.loader()
        var $this = $(this);
        var ids = [$this.attr("option-id")];
        var types = thumbView.find(".variation-type").not($this.parents(".variation-type"));
        types.each(function() {
            ids.push($(this).find(".option-cell.selected").attr("option-id"));
        });
        loadVariation({productId: productId, 'config.options': ids});
    })

    function loadVariation(data) {
        bm.ajax({
            url: app.baseUrl + 'enterpriseVariation/loadVariationProductUrl',
            data: data,
            success: function(resp) {
                if(resp.url) {
                    if (resp.enable_lite_variation_switch) {
                        bm.ajax({
                            url: app.baseUrl + 'variation/variationProductDetails?url=' + resp.url,
                            data: data,
                            dataType: "html",
                            success: function (resp) {

                                if (resp) {
                                    // Preserve the parent product's custom (FEE) page design: replace only the
                                    // product widgets in place instead of swapping the whole .page-content with the
                                    // child variation product's default template (which drops all designed sections).
                                    var newPageContent = resp.jqObject.find(".page-content");
                                    var currentPageContent = $(".page-content");
                                    newPageContent.find(".product-widget[widget-type]").each(function() {
                                        var newWidget = $(this);
                                        var widgetType = newWidget.attr("widget-type");
                                        var currentWidget = currentPageContent.find(".product-widget[widget-type='" + widgetType + "']").first();
                                        if (currentWidget.length) {
                                            currentWidget.replaceWith(newWidget);
                                        }
                                    });
                                    site.hook.fire("bind-site-events");
                                    widget = $(".variation-container");
                                    var type = widget.find(".variation-model");
                                    if(type.length) {
                                        var select = widget.find("div.product-variation-select:not(.combined)");
                                        if(select.length) {
                                            select.chosen({
                                                disable_search_threshold: 10,
                                                disable_search: true
                                            });
                                        }
                                        var func = "initialise" + type.val().capitalize() + "VariationWidget";
                                        bm.onReady(window, func, function() {
                                            window[func](productId, content, widget);
                                        })
                                    }
                                    initialiseEnterpriseVariationWidget(productId, content, widget)
                                    if (window.page && page.productId) {
                                        app.productWidgets.init($("body"), page.productId)
                                        // attachWishListGlobalEvents($(document))
                                    }
                                    site.hook.fire("load-product-details");
                                    widget.loader(false)
                                }
                            }
                        });
                    } else {
                        window.location.href = app.baseUrl + 'product/' + resp.url
                    }
                }
            }
        });
    }

    var addToCart = function (productId, _this, externalProperties){
        var container
        var pageLoader
        if(_this){
            container = _this.closest(".page-content, .popup, .product-block, .add-cart-info-block");
            pageLoader = _this.closest(".page-content");
        }else {
            container = this.jqObject.closest(".page-content, .popup, .product-block, .add-cart-info-block");
            pageLoader = this.jqObject.closest(".page-content");
        }
        if(pageLoader.length){
            pageLoader.loader()
        } else {
            container.loader()
        }

        var data
        if (productId) {
            //data = {}
            //data.productId = productId
            data = new FormData();
            data.append("productId", productId)
        } else {
            var element = $(".incomplete-info-for-variation-ui").find(".custom-field-container")
            //data = element.serializeObject()
            //data.productId = $(this).attr("product-id")
            data = new FormData(element.nat);
            data.append("productId", $(this).attr("product-id"))
            //formData.append("customFile", productId)
        }
        if(externalProperties){
            data.append("externalProperties", externalProperties)
        }

        site.hook.fire("prepareAddCartPreviewData", data, [container, data.productId, data.quantity, false])

        bm.ajax({
            url: app.baseUrl + "variation/addPreviewCartToCart",
            data: data,
            contentType: false,
            processData: false,
            type: 'post',
            success: function(resp) {
                if(pageLoader.length){
                    pageLoader.loader(false)
                } else {
                    container.loader(false)
                }
                var content = $(resp.html);
                if(resp.status == 'added') {
                    site.hook.fire("cartAdded", {})
                    if(resp.externalStep && resp.externalStep.content){
                        site.hook.fire("externalStep", {}, [resp.externalStep])
                        return
                    }
                    renderAddToCartPopup(content);
                } else if(resp.status == 'redirect-to') {
                    window.location.href = app.baseUrl + "product/" + resp.url
                } else if(resp.status == 'incomplete-info') {
                    renderInfoChooserPopup(productId, content, "preview-to-add-to-cart-button", addToCart);
                } else if(resp.status == 'restrict') {
                    if (resp.externalData && resp.externalData.addToCartRestrictionTypeYesNo) {
                        bm.confirm(resp.alrtMessage, function(){
                                if (resp.isFlyingCartEnabled) {
                                    externalProperties = externalProperties ? $.extend(externalProperties, {isAllowedToConvertAllToPreOrder: resp.externalData.isAskToPreOrder}): {isAllowedToConvertAllToPreOrder: resp.externalData.isAskToPreOrder}
                                    externalProperties = JSON.stringify(externalProperties)
                                    addToCart(productId, _this, externalProperties)
                                } else {
                                    window.location.href = app.baseUrl + resp.redirectLink
                                }
                            },
                            function () {
                                externalProperties = externalProperties ? $.extend(externalProperties, {preOrderConversionRequired: false}) : {preOrderConversionRequired: false}
                                externalProperties = JSON.stringify(externalProperties)
                                addToCart(productId, _this, externalProperties)
                            });
                    } else {
                        bm.confirm(resp.alrtMessage, function () {
                            if (resp.isFlyingCartEnabled) {
                                if (!$("#webcommander-page").hasClass("do-not-remove-cart-preview")) {
                                    $("#webcommander-page").addClass("do-not-remove-cart-preview")
                                }
                                loadAdvancedFlyingCart()
                            } else {
                                window.location.href = app.baseUrl + resp.redirectLink
                            }

                        }, undefined, undefined, {yesButtonTitle: "OK"});
                    }
                }
            },
            error: function (resp) {
                if(pageLoader.length){
                    pageLoader.loader(false)
                } else {
                    container.loader(false)
                }
            }
        });
    }

    var updateQuantity = function (variationId, quantity) {
        $(".product-variation-selectable-row.p" + productId + "-v" + variationId +
            " input[product-id='" + productId + "'][product-variation='" + variationId + "']")
            .val(quantity);
    }

    var updatePreview = function (variationId, quantity, removePreviewId){
        var isPreOrder = $(".preorder-product-block-with-add-to-cart").find("input[name='isPreorderProduct']").is(":checked")
        bm.ajax({
            url: app.baseUrl + "variation/manageCartPreview",
            data: {productId: productId, variationId: variationId, quantity: quantity, removePreviewId: removePreviewId, isPreOrder: isPreOrder},
            dataType: "html",
            success: function (resp) {
                var cartPreview = widget.find("#selected-variation-products").html(resp)
                cartPreview.find(".selected-product-quantity .decrease-qty").on("click", function() {
                    var quantityEle = $(this).parent()
                    variationId = quantityEle.attr("vid")
                    quantity = parseInt(quantityEle.attr("quantity")) - 1
                    updatePreview(variationId, quantity, $(this).attr("removePreviewId"))
                    updateQuantity(variationId, quantity)
                    //widget.find(".variation-options-table").find(".variation-option.selected").trigger("click")
                })
                cartPreview.find(".selected-product-quantity .increase-qty").on("click", function() {
                    var quantityEle = $(this).parent()
                    variationId = quantityEle.attr("vid")
                    quantity = parseInt(quantityEle.attr("quantity")) + 1
                    updatePreview(variationId, quantity, $(this).attr("removePreviewId"))
                    updateQuantity(variationId, quantity)
                    //widget.find(".variation-options-table").find(".variation-option.selected").trigger("click")
                })

                cartPreview.find(".remove-preview").on("click", function() {
                    updatePreview(null, null, $(this).attr("removePreviewId"))
                    updateQuantity( $(this).parent().find(".selected-product-quantity").attr("vid"), 0)
                    //widget.find(".variation-options-table").find(".variation-option.selected").trigger("click")
                })

                cartPreview.find(".preview-to-add-to-cart-button").on("click", function() {
                    addToCart($(this).attr("product-id"), $(this))
                })
                if (cartPreview.find(".variation-selected-product").length) {
                    var pageContent = $(".page-content");
                    pageContent.find(".product-widget.widget-addCart").hide();
                    pageContent.find(".product-widget.widget-stockMark").hide();
                } else {
                    var pageContent = $(".page-content");
                    pageContent.find(".product-widget.widget-addCart").show();
                    pageContent.find(".product-widget.widget-stockMark").show();
                }
                widget.loader(false)
            }
        });
    }

    var loadVariationCombinationData = function (productId, selectedOptionId){
        widget.loader()
        bm.ajax({
            url: app.baseUrl + 'variation/loadVariationCombination',
            data: {productId: productId, optionId: selectedOptionId},
            dataType: "html",
            success: function (resp) {
                var content = widget.find("#variation-combination-details")
                if($(".page-content").find(".advanced-variation-ui").length){
                    $(".widget-addCart").find(".add-to-cart-button").addClass("disabled")
                }
                content.html(resp)
                var totalCombinations = content.find(".variation-product-selector-stepper-input.text-type").length
                content.find(".variation-product-selector-stepper-input.text-type").each(function (index, ele) {
                    var spin = $(this);
                    var data = spin.config("spin")
                    spin.stepper(data)
                    if(totalCombinations === index +1){
                        updatePreview(null, null, null)
                    }
                    spin.on("change", function() {
                        var quantityInput = this.jqObject
                        var variationId = quantityInput.attr("product-variation");
                        var quantity = quantityInput.val();
                        updatePreview(variationId, quantity, null)
                    }).numeric()
                })
                widget.loader(false)
            }
        });
    }

    widget.find(".variation-option:not(.parent-option)").on("click", function () {
        widget.find(".variation-option").removeClass("selected")
        $(".page-content").find(".product-widget.widget-addCart").find(".add-to-cart-button").addClass("disabled")
        var _this = $(this);
        _this.addClass("selected")
        loadVariationCombinationData(productId, _this.attr("optionId"))
    })

    var selectedOptionId = widget.find(".variation-options-table").find(".variation-option.selected").attr("optionId")
    loadVariationCombinationData(productId, selectedOptionId)

}

site.hook.register("removeCart", function(page) {
    /*if ($("#webcommander-page").hasClass("do-not-remove-cart-preview")) {
        return
    }*/
    var selectedVariationProducts = page.find("#selected-variation-products .selected-variation-product");
    selectedVariationProducts.remove();
    page.find(".product-widget.widget-addCart").show();
    page.find(".variation-product-selector-stepper-input").val(0);
});